/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TimeClockMoveForwardIcon16Light = forwardRef('TimeClockMoveForwardIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M6.465 2.098A5.5 5.5 0 0 1 12.4 5H10.5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 .5-.5V2.252a.5.5 0 0 0-1 0v1.784a6.5 6.5 0 1 0 .629 5.63.5.5 0 1 0-.943-.333 5.5 5.5 0 1 1-6.22-7.235Z" }),
        React.createElement("path", { d: "M8 4.402a.5.5 0 1 0-1 0v2.325c0 .663.375 1.27.967 1.566l2.31 1.154a.5.5 0 1 0 .447-.894l-2.31-1.155A.75.75 0 0 1 8 6.728V4.401Z" })));
});
